import { variableNormalizer } from "@/utils/graphql";

export const getTeachers = () => {
  return {
    name: "getTeachers",
    ql: {
      query: `
      {
        getTeachers{
          id
          code
          firstNameLocal
          lastNameLocal
          firstNameEng
          lastNameEng
          availableTime
          telephone
          email
          picturePath
          socialMedia
          isSpecialTeacher
          isActive
          curriculum{
            id
            currId
            code
            nameLocal
            nameEng
          }
          faculty{
            id
            code
            nameLocal
            nameEng
          }
          prefix{
            id
            nameLocal
            nameEng
            nameShortLocal
            nameShortEng
          }
          user{
            id
            code
            userLogin
            userGroup{
              id
              code
              nameLocal
              nameEng
            }
            email
          }
        }
      }`
    }
  }
};

export const getTeacherById = (id) => {
  return {
    name: 'getTeacher',
    ql: {
      query: `
        {
          getTeacher(id: "${id}")
          {
            id
            code
            firstNameLocal
            lastNameLocal
            firstNameEng
            lastNameEng
            availableTime
            telephone
            email
            picturePath
            socialMedia
            isSpecialTeacher
            isActive
            curriculum{
              id
              currId
              code
              nameLocal
              nameEng
            }
            faculty{
              id
              code
              nameLocal
              nameEng
            }
            prefix{
              id
              nameLocal
              nameEng
              nameShortLocal
              nameShortEng
            }
            user{
              id
              code
              userLogin
              userGroup{
                id
                code
                nameLocal
                nameEng
              }
              email
            }
          }
        }`
    }
  }
};

export const getTeacherByFilter = ({
                                     code = null,
                                     firstNameLocal = null,
                                     lastNameLocal = null,
                                     firstNameEng = null,
                                     lastNameEng = null,
                                     telephone = null,
                                     email = null,
                                     isSpecialTeacher = null,
                                     isActive = null,
                                     curriculumId = null,
                                     facultyId = null,
                                   }) => {
  return {
    name: 'getTeacherByFilter',
    ql: {
      query: `
        {
          getTeacher(
            teacherInput: {
              code: ${variableNormalizer(code)}
              firstNameLocal: ${variableNormalizer(firstNameLocal)}
              lastNameLocal: ${variableNormalizer(lastNameLocal)}
              firstNameEng: ${variableNormalizer(firstNameEng)}
              lastNameEng: ${variableNormalizer(lastNameEng)}
              telephone: ${variableNormalizer(telephone)}
              email: ${variableNormalizer(email)}
              isSpecialTeacher: ${variableNormalizer(isSpecialTeacher)}
              isActive: ${variableNormalizer(isActive)}
              curriculumId: ${variableNormalizer(curriculumId)}
              facultyId: ${variableNormalizer(facultyId)}
            }
          )
          {
            id
            code
            firstNameLocal
            lastNameLocal
            firstNameEng
            lastNameEng
            availableTime
            telephone
            email
            picturePath
            socialMedia
            isSpecialTeacher
            isActive
            curriculum{
              id
              currId
              code
              nameLocal
              nameEng
            }
            faculty{
              id
              code
              nameLocal
              nameEng
            }
            prefix{
              id
              nameLocal
              nameEng
              nameShortLocal
              nameShortEng
            }
            user{
              id
              code
              userLogin
              userGroup{
                id
                code
                nameLocal
                nameEng
              }
              email
            }
          }
        }`
    }
  }
};

export const addTeacher = ({
                             code = null,
                             firstNameLocal = null,
                             lastNameLocal = null,
                             firstNameEng = null,
                             lastNameEng = null,
                             availableTime = null,
                             telephone = null,
                             email = null,
                             picturePath = null,
                             socialMedia = null,
                             isSpecialTeacher = null,
                             isActive = null,
                             curriculumId = null,
                             facultyId = null,
                             prefixId = null,
                             userId = null
                           }) => {
  return {
    name: "addTeacher",
    ql: {
      query: `
        mutation {
          addTeacher(
            teacherInput: {
              code: ${variableNormalizer(code)}
              firstNameLocal: ${variableNormalizer(firstNameLocal)}
              lastNameLocal: ${variableNormalizer(lastNameLocal)}
              firstNameEng: ${variableNormalizer(firstNameEng)}
              lastNameEng: ${variableNormalizer(lastNameEng)}
              availableTime: ${variableNormalizer(availableTime)}
              telephone: ${variableNormalizer(telephone)}
              email: ${variableNormalizer(email)}
              picturePath: ${variableNormalizer(picturePath)}
              socialMedia: ${variableNormalizer(socialMedia)}
              isSpecialTeacher: ${variableNormalizer(isSpecialTeacher)}
              isActive: ${variableNormalizer(isActive)}
            }
            curriculumId: ${variableNormalizer(curriculumId)}
            facultyId: ${variableNormalizer(facultyId)}
            prefixId: ${variableNormalizer(prefixId)}
            userId: ${variableNormalizer(userId)}
          )
          {
            id
            code
            firstNameLocal
            lastNameLocal
            firstNameEng
            lastNameEng
            availableTime
            telephone
            email
            picturePath
            socialMedia
            isSpecialTeacher
            isActive
            curriculum{
              id
              currId
              code
              nameLocal
              nameEng
            }
            faculty{
              id
              code
              nameLocal
              nameEng
            }
            prefix{
              id
              nameLocal
              nameEng
              nameShortLocal
              nameShortEng
            }
            user{
              id
              code
              userLogin
              userGroup{
                id
                code
                nameLocal
                nameEng
              }
              email
            }
          }
        }
      `
    }
  }
};

export const updateTeacher = ({
                                id = null,
                                code = null,
                                firstNameLocal = null,
                                lastNameLocal = null,
                                firstNameEng = null,
                                lastNameEng = null,
                                availableTime = null,
                                telephone = null,
                                email = null,
                                picturePath = null,
                                socialMedia = null,
                                isSpecialTeacher = null,
                                isActive = null,
                                curriculumId = null,
                                facultyId = null,
                                prefixId = null,
                                userId = null
                              }) => {
  return {
    name: "",
    ql: {
      query: `
        mutation {
          updateTeacher(
            id: "${id}"
            teacherInput: {
              code: ${variableNormalizer(code)}
              firstNameLocal: ${variableNormalizer(firstNameLocal)}
              lastNameLocal: ${variableNormalizer(lastNameLocal)}
              firstNameEng: ${variableNormalizer(firstNameEng)}
              lastNameEng: ${variableNormalizer(lastNameEng)}
              availableTime: ${variableNormalizer(availableTime)}
              telephone: ${variableNormalizer(telephone)}
              email: ${variableNormalizer(email)}
              picturePath: ${variableNormalizer(picturePath)}
              socialMedia: ${variableNormalizer(socialMedia)}
              isSpecialTeacher: ${variableNormalizer(isSpecialTeacher)}
              isActive: ${variableNormalizer(isActive)}
            }
            curriculumId: ${variableNormalizer(curriculumId)}
            facultyId: ${variableNormalizer(facultyId)}
            prefixId: ${variableNormalizer(prefixId)}
            userId: ${variableNormalizer(userId)}
          )
          {
            id
            code
            firstNameLocal
            lastNameLocal
            firstNameEng
            lastNameEng
            availableTime
            telephone
            email
            picturePath
            socialMedia
            isSpecialTeacher
            isActive
            curriculum{
              id
              currId
              code
              nameLocal
              nameEng
            }
            faculty{
              id
              code
              nameLocal
              nameEng
            }
            prefix{
              id
              nameLocal
              nameEng
              nameShortLocal
              nameShortEng
            }
            user{
              id
              code
              userLogin
              userGroup{
                id
                code
                nameLocal
                nameEng
              }
              email
            }
          }
        }
      `
    }
  }
};

export const deleteTeacherById = (id) => {
  return {
    name: 'deleteTeacher',
    ql: {
      query: `
         mutation {
          deleteTeacher (
            id: "${id}"
          )
          {
            id
          }
      }`
    }
  }
};
